module.exports = __webpack_public_path__ + "img/thumb_2019-01.e8fa0ddd.jpg";